import React from 'react';

function MoveHistory(props) {
  return (
    <div className="move-history-container flex-container mt-2">
      <div className="move-prev me-3">
        <button onClick={props.goBack} className="btn btn-outline-secondary">
          <i className="bi bi-caret-left-fill"></i>
        </button>
      </div>
      <div className="move-history-range">
        <input type="range" className="move-history-range-input form-range"
          min="0" max={props.maxMoveNumber}
          onChange={props.onChange}
          value={props.moveNumber} />
      </div>
      <div className="move-next ms-3">
        <button onClick={props.goForward} className="btn btn-outline-secondary">
          <i className="bi bi-caret-right-fill"></i>
        </button>
      </div>
      <div className="move-number ms-2 pe-1">
        {props.moveNumber}
      </div>
    </div>
  );
}

export default MoveHistory;